<template>
  <el-tag v-bind="$attrs">{{ props.noModel }}</el-tag>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "form-tag",
  inheritAttrs: false,
  props: {
    config: {
      type: Object,
      required: true
    },
    noModel: {
      type: String
    }
  },
  emits: ["change"],
  setup(props) {
    return {
      props
    };
  }
});
</script>
